export const INDICATOR = {
    NO_SYMPTOM: "NoSymptoms",
    NO_INDICATOR: "NoIndicators",
    O_VASK: "O_Vascular",
    O_NERV: "O_Nerv",
    O_HORM: "O_Hormonal",
    O_PSYK: "O_Psychological",
    KO_ALK: "KO_Alcohol",
    KO_HJART: "KO_Heart",
    KO_STROKE: "KO_Stroke",
    KO_LEV_NJUR: "KO_LiverKidney",
    KO_BLODTRYCK: "KO_BloodPressure",
    KO_ANATOMI: "KO_Anatomy",
    KO_TVASK: "KO_TraumaticVascular",
    KO_LAKEMEDEL: "KO_Medicine",
    KO_LAKEMEDEL_ADEMPAS: "KO_MedicineAdempas",
    KO_LAKEMEDEL_HIV: "KO_MedicineHiv",
    KO_LAKEMEDEL_CANCER: "KO_MedicineCancer",
    KO_HJART_OCH_STROKE: "KO_HeartAndStroke",
    KO_BLODTRYCK_OCH_LEV_NJUR: "KO_BloodPressureAndLiverKidney",
    KO_BLODTRYCK_OCH_ANATOMI: "KO_BloodPressureAndAnatomy",
    KO_ANATOMI_OCH_LEV_NJUR: "KO_AnatomyAndLiverKidney",
    KO_BLODTRYCK_OCH_ANATOMI_OCH_LEV_NJUR: "KO_BloodPressureAndAnatomyAndLiverKidney",
    KO_LAKEMEDEL_HIV_OCH_CANCER: "KO_MedicineHivAndCancer",
    LAKEMEDEL: "AnyMedicine",
    RECEPT: "Recipe"
};